module.exports = __webpack_public_path__ + "img/3.47b5b4b1.png";